/** Returns a 24-char hex Mongo ObjectId string or null if invalid / placeholder. */
export function parseMongoObjectId(value) {
    if (value == null) return null;
    const s = String(value).trim();
    if (!s || /^null$/i.test(s) || /^undefined$/i.test(s)) return null;
    return /^[a-fA-F0-9]{24}$/.test(s) ? s : null;
}

export function isValidMongoObjectId(value) {
    return parseMongoObjectId(value) != null;
}
